(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-articles"] && !window.DesignMode) return;
  try {
    
    var splide6 = new Splide( '.splide6', {
    type: 'loop',
    perPage: 3,
    autoplay: false,
    interval: 8000,
    flickMaxPages: 3,
    updateOnMove: true,
    pagination: false,
    arrows: false,
    perMove: 1,
    gap    : '29px',
    breakpoints: {
        1024: {
            perPage: 3,
            gap: 20,
          },
          767: {
            perPage: 2,
            autoplay: true,
            arrows: false,
            gap: 20,
          },
          480: {
            perPage: 1,
            gap: 10,
            autoplay: true,
            arrows: false,
            padding:'120px',
          }
      },
  } );
  
  splide6.mount();
  
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["advantage-gen"] && !window.DesignMode) return;
  try {
    
$('.slider_advant').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: { 
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,
            prevArrow:'<button type="button" class="slick-prev pull-left" aria-label="Previous Button"><svg width="12" height="19" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 1L2 9.04762L11 17.7143" stroke="#B29D95" stroke-width="1.5"/></svg></button>',
          nextArrow:'<button type="button" class="slick-next pull-right" aria-label="Next Button"><svg width="12" height="19" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L10 9.04762L1 17.7143" stroke="#B29D95" stroke-width="1.5"/></svg></button>',
       } 
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["advantage-gen2"] && !window.DesignMode) return;
  try {
    
  var splide3 = new Splide( '.splide3', {
  type: 'loop',
  perPage: 3,
  autoplay: false,
  interval: 8000,
  flickMaxPages: 3,
  updateOnMove: true,
  pagination: false,
  arrows: false,
  perMove: 1,
  gap    : '50px',
  breakpoints: {
      1024: {
          perPage: 3
        },
        767: {
          perPage: 2,
          autoplay: true,
          arrows: true,
        },
        480: {
          perPage: 1,
          gap: 10,
          autoplay: true,
          arrows: true,
        }
    },
} );

splide3.mount();

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adv_personalise_pdp"] && !window.DesignMode) return;
  try {
    
$('.slider_advant').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: { 
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,
            prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="12" height="19" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 1L2 9.04762L11 17.7143" stroke="#B29D95" stroke-width="1.5"/></svg></button>',
          nextArrow:'<button type="button" class="slick-next pull-right"><svg width="12" height="19" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L10 9.04762L1 17.7143" stroke="#B29D95" stroke-width="1.5"/></svg></button>',
       } 
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-seller"] && !window.DesignMode) return;
  try {
    
  var shopByStyle = new Splide( '.shop-by-style', {
  type: 'loop',
  perPage: 5,
  //autoplay: true,
  //interval: 8000,
  flickMaxPages: 3,
  updateOnMove: true,
  pagination: false,
  arrows: true,
  perMove: 1,
  gap    : '23px',
  breakpoints: {
      1024: {
          perPage: 3,
          arrows:false
        },
        767: {
          perPage: 1,
          padding:'10%',
        },
        480: {
          perPage: 1,
          padding:'127px',
          gap: 10,
        }
    },
} );

shopByStyle.mount();

    var shopByStylemin = new Splide( '.shop-by-style_min', {
  type: 'loop',
  perPage: 1,
  autoplay: true,
  interval: 8000,
  flickMaxPages: 1,
  updateOnMove: true,
  pagination: true,
  arrows: true,
  perMove: 1,
  gap    : '23px',
  breakpoints: {
      1024: {
          perPage: 1,
          arrows:false
        },
        767: {
          perPage: 1,
          padding:'0%',
        },
        480: {
          perPage: 1,
          padding:'0',
          gap: 10,
        }
    },
} );

shopByStylemin.mount();

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-seller2"] && !window.DesignMode) return;
  try {
    
    var shopByStyle = new Splide( '.shop-by-style2', {
    type: 'loop',
    perPage: 4,
    //autoplay: true,
    //interval: 8000,
    flickMaxPages: 3,
    updateOnMove: true,
    pagination: false,
    arrows: false,
    perMove: 1,
    gap    : '23px',
    breakpoints: {
        1024: {
            perPage: 3,
            arrows:true
          },
          767: {
            perPage: 2,
            arrows: true,
            padding:'5%',
          },
          480: {
            perPage: 2,
            arrows: true,
            padding:'40px',
            gap: 10,
          }
      },
  } );
  
  shopByStyle.mount();

  
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-seller3"] && !window.DesignMode) return;
  try {
    
    var shopByStyle = new Splide( '.shop-by-style3', {
    type: 'loop',
    perPage: 5,
    autoplay: true,
    interval: 8000,
    flickMaxPages: 3,
    updateOnMove: true,
    pagination: false,
    arrows: true,
    perMove: 1,
    gap    : '23px',
    breakpoints: {
        1024: {
            perPage: 3,
            arrows:false
          },
          767: {
            perPage: 2,
            padding:'5%',
          },
          480: {
            perPage: 2,
            padding:'40px',
            gap: 10,
          }
      },
  } );
  
  shopByStyle.mount();

  
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-landing-products"] && !window.DesignMode) return;
  try {
    
  var splide2 = new Splide( '.splide2', {
  type: 'loop',
  perPage: 4,
  //autoplay: true,
  //interval: 8000,
  flickMaxPages: 3,
  updateOnMove: true,
  pagination: false,
  arrows: false,
  perMove: 1,
  gap    : '45px',
  breakpoints: {
      1024: {
          perPage: 3
        },
        767: {
          perPage: 2,
          padding:'25px'
        },
        480: {
          perPage: 2,
          padding:'160px',
          gap: 10,
        }
    },
} );

splide2.mount();

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloglanding-collection"] && !window.DesignMode) return;
  try {
    

var splide = new Splide( '.splide', {
  perPage: 5,
  focus: 'center',
  autoplay: false,
  interval: 8000,
  flickMaxPages: 3,
  updateOnMove: false,
  pagination: false,
  arrows: false,
  perMove: 1,
  type:'loop',
  gap    : '25px',
  breakpoints: {
      1024: {
          perPage: 3
        },
        767: {
          perPage: 2,
          padding:'10%'
        },
        480: {
          perPage: 2,
          padding:'127px',
          gap: 10,
        }
    },
} );

splide.mount();



  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["career-locations"] && !window.DesignMode) return;
  try {
    
    var splide4 = new Splide( '.splide4', {
    perPage: 5,
    padding:'5%',
    //autoplay: true,
    //interval: 8000,
    flickMaxPages: 4,
    updateOnMove: true,
    pagination: false,
    arrows: false,
    perMove: 1,
    gap    : '32px',
    drag:false,
    breakpoints: {
        1024: {
            perPage: 3,
            gap: 20,
          },
          767: {
            perPage: 2,
            autoplay: true,
            arrows: false,
            gap: 20,
            padding:'100%',
            drag:true,
          },
          480: {
            perPage: 2,
            gap: 20,
            autoplay: true,
            arrows: false,
            padding:'100%',
            type:'loop',
            drag:true,
          }
      },
  } );
  
  splide4.mount();
  
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel"] && !window.DesignMode) return;
  try {
    
// Go to corresponding slide on Shopify's editor
document.addEventListener('shopify:block:select', (e) => {
    const carouselEl = e.target.closest('.carousel')

    if (carouselEl) {
        const selectedSlide = e.target.dataset.index
        bootstrap.Carousel.getOrCreateInstance(carouselEl, { interval: false }).to(selectedSlide)
    }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart_collection"] && !window.DesignMode) return;
  try {
    
  var shopByStyle = new Splide( '.shop-by-style', {
  type: 'loop',
  perPage: 4,
  autoplay: false,
  interval: 8000,
  flickMaxPages: 3,
  updateOnMove: true,
  pagination: false,
  arrows: false,
  perMove: 1,
  gap    : '23px',
  breakpoints: {
      1024: {
          perPage: 3,
          arrows:false
        },
        767: {
          perPage: 1,
          padding:'10%',
        },
        480: {
          perPage: 1,
          padding:'127px',
          gap: 10,
        }
    },
} );

shopByStyle.mount();

    var shopByStylemin = new Splide( '.shop-by-style_min', {
  type: 'loop',
  perPage: 1,
  autoplay: true,
  interval: 8000,
  flickMaxPages: 1,
  updateOnMove: true,
  pagination: true,
  arrows: true,
  perMove: 1,
  gap    : '23px',
  breakpoints: {
      1024: {
          perPage: 1,
          arrows:false
        },
        767: {
          perPage: 1,
          padding:'0%',
        },
        480: {
          perPage: 1,
          padding:'0',
          gap: 10,
        }
    },
} );

shopByStylemin.mount();

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["competitive-advantage-explore"] && !window.DesignMode) return;
  try {
    
    var splide7 = new Splide( '.splide7', {
    type: 'loop',
    perPage: 3,
    //autoplay: true,
    //interval: 8000,
    flickMaxPages: 4,
    updateOnMove: true,
    pagination: false,
    arrows: true,
    perMove: 1,
    gap    : '29px',
    breakpoints: {
        1024: {
            perPage: 3,
            gap: 20,
            autoplay: true,
            arrows: false,
          },
          767: {
            perPage: 2,
            autoplay: true,
            arrows: false,
            gap: 20,
            padding:'120px',
          },
          480: {
            perPage: 1,
            gap: 20,
            autoplay: true,
            arrows: false,
            padding:'120px',
          }
      },
  } );
  
  splide7.mount();
  
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["complete-the-look-CL"] && !window.DesignMode) return;
  try {
    
  let completeBook = new Splide( '.complete-book', {
  // type: 'loop',
  perPage: 3,
  //autoplay: true,
  //interval: 8000,
  flickMaxPages: 3,
  updateOnMove: true,
  pagination: false,
  arrows: true,
  perMove: 1,
  gap    : '94px',
  breakpoints: {
      1024: {
          perPage: 3
        },
        767: {
          perPage: 2,
          padding:'10%',
        },
        480: {
          perPage: 1
        }
    },
} );

completeBook.mount();

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["designers-block"] && !window.DesignMode) return;
  try {
    

$('.fadeslider').slick({
  draggable: true,
  autoplay: true,
  autoplaySpeed: 100,
  arrows: false,
  dots: false,
  fade: true,
  speed: 100,
  infinite: true,
  cssEase: 'easeOutElastic',
  touchThreshold: 100
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // class LocalizationForm extends HTMLElement {
  //   constructor() {
  //     super();
  //     this.elements = {
  //       input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
  //       button: this.querySelector('button'),
  //       panel: this.querySelector('.disclosure__list-wrapper'),
  //     };
  //     this.elements.button.addEventListener('click', this.openSelector.bind(this));
  //     this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
  //     this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

  //     this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  //   }

  //   hidePanel() {
  //     this.elements.button.setAttribute('aria-expanded', 'false');
  //     this.elements.panel.setAttribute('hidden', true);
  //   }

  //   onContainerKeyUp(event) {
  //     if (event.code.toUpperCase() !== 'ESCAPE') return;

  //     this.hidePanel();
  //     this.elements.button.focus();
  //   }

  //   onItemClick(event) {
  //     event.preventDefault();
  //     const form = this.querySelector('form');
  //     this.elements.input.value = event.currentTarget.dataset.value;
  //     if (form) form.submit();
  //   }

  //   openSelector() {
  //     this.elements.button.focus();
  //     this.elements.panel.toggleAttribute('hidden');
  //     this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  //   }

  //   closeSelector(event) {
  //     const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
  //     if (event.relatedTarget === null || shouldClose) {
  //       this.hidePanel();
  //     }
  //   }
  // }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["general-collection-more-filter"] && !window.DesignMode) return;
  try {
    
$(function() {
  
  setCheckboxSelectLabels();
  $("button.form-select").html("All");
  $('.toggle-next').click(function() {
    $(this).next('.checkboxes').slideToggle(400);
    var destination = $("#advFilter .modal-body ").offset().top + $("#advFilter .modal-body").height();
    $("#advFilter .modal-body").animate({ scrollTop: destination},"slow");
  });

    $(document).on('click', function(e) {
    var container = $(".toggle-next");
    if ($(e.target).closest(container).length == 0 && $(e.target).closest($("#Categories")).length == 0 ) {
    
        $("#Categories").hide();
    }
});
  
  $('.ckkBox').change(function() {
    toggleCheckedAll(this);
    setCheckboxSelectLabels(); 
  });

 
 
});
  
function setCheckboxSelectLabels(elem) {
  var wrappers = $('.wrapper'); 
   $(".designer_multiselector").find('button').text("Select");
  $.each( wrappers, function( key, wrapper ) {
    var checkboxes = $(wrapper).find('.ckkBox');
    var label = $(wrapper).find('.checkboxes').attr('id');
    var prevText = '';
    $.each( checkboxes, function( i, checkbox ) {
      var button = $(wrapper).find('button');
      if( $(checkbox).prop('checked') == true) {
        var text = $(checkbox).next().html();
        var btnText = prevText + text;
        var numberOfChecked = $(wrapper).find('input.val:checkbox:checked').length;
        if(numberOfChecked >= 4) {
           btnText = numberOfChecked +' Designers selected';
        }
        $(button).text(btnText); 
        prevText = btnText + ', ';
      }
    });
  });
}

function toggleCheckedAll(checkbox) {
  var apply = $(checkbox).closest('.wrapper').find('.apply-selection');
  apply.fadeIn('slow'); 
  
  var val = $(checkbox).closest('.checkboxes').find('.val');
  var all = $(checkbox).closest('.checkboxes').find('.all');
  var ckkBox = $(checkbox).closest('.checkboxes').find('.ckkBox');

  if(!$(ckkBox).is(':checked')) {
    $(all).prop('checked', true);
    return;
  }

  if( $(checkbox).hasClass('all') ) {
    $(val).prop('checked', false);
  } else {
    $(all).prop('checked', false);
  }
}
  
var a = document.querySelectorAll(".circleMetal li");
for (var i = 0, length = a.length; i < length; i++) {
  a[i].onclick = function() {
    var b = document.querySelector(".circleMetal li.active");
    if (b) b.classList.remove("active");   
    this.parentNode.classList.add('active');
  };
}

/* -------------------------------------------------------------------------
      Budget begin Style-2
* ------------------------------------------------------------------------- */
   
var budgetPress = document.querySelector(".budget-range");
var input11 = document.querySelector(".budget-num-start");
var input12 = document.querySelector(".budget-num-end");
var inputs = [input11, input12];

noUiSlider.create(budgetPress, {
  start: [0,  3000],
  connect: true,
//   step: 1,
  range: {
    min: [0],
    max: [3000]
  },
  format: wNumb({
        decimals: 0,
        thousand: ',',
        prefix: '$ '
    })
});

/* begin Inputs  */

/* end Inputs  */
budgetPress.noUiSlider.on("update", function(values, handle) {
  inputs[handle].value = values[handle];

  /* begin Listen to keypress on the input */
  function setSliderHandle(i, value) {
    var r = [null, null];
    r[i] = value;
    budgetPress.noUiSlider.set(r);
  }

  // Listen to keydown events on the input field.
  inputs.forEach(function(input, handle) {
    input.addEventListener("change", function() {
      setSliderHandle(handle, this.value);
    });

    input.addEventListener("keydown", function(e) {
      var values = budgetPress.noUiSlider.get();
      var value = Number(values[handle]);

      // [[handle0_down, handle0_up], [handle1_down, handle1_up]]
      var steps = budgetPress.noUiSlider.steps();

      // [down, up]
      var step = steps[handle];

      var position;

      // 13 is enter,
      // 38 is key up,
      // 40 is key down.
      switch (e.which) {
        case 13:
          setSliderHandle(handle, this.value);
          break;

        case 38:
          // Get step to go increase slider value (up)
          position = step[1];

          // false = no step is set
          if (position === false) {
            position = 1;
          }

          // null = edge of slider
          if (position !== null) {
            setSliderHandle(handle, value + position);
          }

          break;

        case 40:
          position = step[0];

          if (position === false) {
            position = 1;
          }

          if (position !== null) {
            setSliderHandle(handle, value - position);
          }

          break;
      }
    });
  });
  /* end Listen to keypress on the input */
});

    
    /* -------------------------------------------------------------------------
       Budget end Style-2
     * ------------------------------------------------------------------------- */


/* -------------------------------------------------------------------------
      Budget Begin Start
* ------------------------------------------------------------------------- */
   
var budgetMinPress = document.querySelector(".budget-range-min");
var input25 = document.querySelector(".budget-num-start");
var input26 = document.querySelector(".budget-num-end");
var inputs = [input25, input26];

noUiSlider.create(budgetMinPress, {
  start: [0,  999900],
  connect: true,
//   step: 1,
  range: {
    min: [0],
    max: [1000000]
  },
  format: wNumb({
        decimals: 0,
        thousand: ',',
        prefix: '$ '
    })
});

/* begin Inputs  */

/* end Inputs  */
budgetMinPress.noUiSlider.on("update", function(values, handle) {
  inputs[handle].value = values[handle];

  /* begin Listen to keypress on the input */
  function setSliderHandle(i, value) {
                           var r = [null, null];
    r[i] = value;
    budgetMinPress.noUiSlider.set(r);
  }

  // Listen to keydown events on the input field.
  inputs.forEach(function(input, handle) {
    input.addEventListener("change", function() {
      setSliderHandle(handle, this.value);
    });

    input.addEventListener("keydown", function(e) {
      var values = budgetMinPress.noUiSlider.get();
      var value = Number(values[handle]);

      // [[handle0_down, handle0_up], [handle1_down, handle1_up]]
      var steps = budgetMinPress.noUiSlider.steps();

      // [down, up]
      var step = steps[handle];

      var position;

      // 13 is enter,
      // 38 is key up,
      // 40 is key down.
      switch (e.which) {
        case 13:
          setSliderHandle(handle, this.value);
          break;

        case 38:
          // Get step to go increase slider value (up)
          position = step[1];

          // false = no step is set
          if (position === false) {
            position = 1;
          }

          // null = edge of slider
          if (position !== null) {
            setSliderHandle(handle, value + position);
          }

          break;

        case 40:
          position = step[0];

          if (position === false) {
            position = 1;
          }

          if (position !== null) {
            setSliderHandle(handle, value - position);
          }

          break;
      }
    });
  });
  /* end Listen to keypress on the input */
});


/* -------------------------------------------------------------------------
    Budget End Footer
* ------------------------------------------------------------------------- */


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["general-more-filter"] && !window.DesignMode) return;
  try {
    
$(function() {
  
  setCheckboxSelectLabels();
  $("button.form-select").html("All");
  $('.toggle-next').click(function() {

     if (!window.location.pathname.includes('start-with-a-setting')) {
        console.log("check - window.location.pathname",window.location.pathname)
            $(this).next('.checkboxes').slideToggle(400);
      }

    var destination = $("#advFilter .modal-body ").offset().top + $("#advFilter .modal-body").height();
      $("#advFilter .modal-body").animate({ scrollTop: destination},"slow");
    
  });

    $(document).on('click', function(e) {
    var container = $(".toggle-next");
    if ($(e.target).closest(container).length == 0 && $(e.target).closest($("#Categories")).length == 0 ) {
    
        $("#Categories").hide();
    }
});
  
  $('.ckkBox').change(function() {
    toggleCheckedAll(this);
    setCheckboxSelectLabels(); 
  });

 
 
});
  
function setCheckboxSelectLabels(elem) {
  var wrappers = $('.wrapper'); 
   $(".designer_multiselector").find('button').text("Select");
  $.each( wrappers, function( key, wrapper ) {
    var checkboxes = $(wrapper).find('.ckkBox');
    var label = $(wrapper).find('.checkboxes').attr('id');
    var prevText = '';
    $.each( checkboxes, function( i, checkbox ) {
      var button = $(wrapper).find('button');
      if( $(checkbox).prop('checked') == true) {
        var text = $(checkbox).next().html();
        var btnText = prevText + text;
        var numberOfChecked = $(wrapper).find('input.val:checkbox:checked').length;
        if(numberOfChecked >= 4) {
           btnText = numberOfChecked +' Designers selected';
        }
        $(button).text(btnText); 
        prevText = btnText + ', ';
      }
    });
  });
}

function toggleCheckedAll(checkbox) {
  var apply = $(checkbox).closest('.wrapper').find('.apply-selection');
  apply.fadeIn('slow'); 
  
  var val = $(checkbox).closest('.checkboxes').find('.val');
  var all = $(checkbox).closest('.checkboxes').find('.all');
  var ckkBox = $(checkbox).closest('.checkboxes').find('.ckkBox');

  if(!$(ckkBox).is(':checked')) {
    $(all).prop('checked', true);
    return;
  }

  if( $(checkbox).hasClass('all') ) {
    $(val).prop('checked', false);
  } else {
    $(all).prop('checked', false);
  }
}
  
var a = document.querySelectorAll(".circleMetal li");
for (var i = 0, length = a.length; i < length; i++) {
  a[i].onclick = function() {
    var b = document.querySelector(".circleMetal li.active");
    if (b) b.classList.remove("active");   
    this.parentNode.classList.add('active');
  };
}

/* -------------------------------------------------------------------------
      Budget begin Style-2
* ------------------------------------------------------------------------- */
   
var budgetPress = document.querySelector(".budget-range");
var input11 = document.querySelector(".budget-num-start");
var input12 = document.querySelector(".budget-num-end");
var inputs = [input11, input12];

noUiSlider.create(budgetPress, {
  start: [0,  3000],
  connect: true,
//   step: 1,
  range: {
    min: [0],
    max: [3000]
  },
  format: wNumb({
        decimals: 0,
        thousand: ',',
        prefix: '$ '
    })
});

/* begin Inputs  */

/* end Inputs  */
budgetPress.noUiSlider.on("update", function(values, handle) {
  inputs[handle].value = values[handle];

  /* begin Listen to keypress on the input */
  function setSliderHandle(i, value) {
    var r = [null, null];
    r[i] = value;
    budgetPress.noUiSlider.set(r);
  }

  // Listen to keydown events on the input field.
  inputs.forEach(function(input, handle) {
    input.addEventListener("change", function() {
      setSliderHandle(handle, this.value);
    });

    input.addEventListener("keydown", function(e) {
      var values = budgetPress.noUiSlider.get();
      var value = Number(values[handle]);

      // [[handle0_down, handle0_up], [handle1_down, handle1_up]]
      var steps = budgetPress.noUiSlider.steps();

      // [down, up]
      var step = steps[handle];

      var position;

      // 13 is enter,
      // 38 is key up,
      // 40 is key down.
      switch (e.which) {
        case 13:
          setSliderHandle(handle, this.value);
          break;

        case 38:
          // Get step to go increase slider value (up)
          position = step[1];

          // false = no step is set
          if (position === false) {
            position = 1;
          }

          // null = edge of slider
          if (position !== null) {
            setSliderHandle(handle, value + position);
          }

          break;

        case 40:
          position = step[0];

          if (position === false) {
            position = 1;
          }

          if (position !== null) {
            setSliderHandle(handle, value - position);
          }

          break;
      }
    });
  });
  /* end Listen to keypress on the input */
});

    
    /* -------------------------------------------------------------------------
       Budget end Style-2
     * ------------------------------------------------------------------------- */


/* -------------------------------------------------------------------------
      Budget Begin Start
* ------------------------------------------------------------------------- */
   
var budgetMinPress = document.querySelector(".budget-range-min");
var input25 = document.querySelector(".budget-num-start");
var input26 = document.querySelector(".budget-num-end");
var inputs = [input25, input26];

noUiSlider.create(budgetMinPress, {
  start: [0,  999900],
  connect: true,
//   step: 1,
  range: {
    min: [0],
    max: [1000000]
  },
  format: wNumb({
        decimals: 0,
        thousand: ',',
        prefix: '$ '
    })
});

/* begin Inputs  */

/* end Inputs  */
budgetMinPress.noUiSlider.on("update", function(values, handle) {
  inputs[handle].value = values[handle];

  /* begin Listen to keypress on the input */
  function setSliderHandle(i, value) {
                           var r = [null, null];
    r[i] = value;
    budgetMinPress.noUiSlider.set(r);
  }

  // Listen to keydown events on the input field.
  inputs.forEach(function(input, handle) {
    input.addEventListener("change", function() {
      setSliderHandle(handle, this.value);
    });

    input.addEventListener("keydown", function(e) {
      var values = budgetMinPress.noUiSlider.get();
      var value = Number(values[handle]);

      // [[handle0_down, handle0_up], [handle1_down, handle1_up]]
      var steps = budgetMinPress.noUiSlider.steps();

      // [down, up]
      var step = steps[handle];

      var position;

      // 13 is enter,
      // 38 is key up,
      // 40 is key down.
      switch (e.which) {
        case 13:
          setSliderHandle(handle, this.value);
          break;

        case 38:
          // Get step to go increase slider value (up)
          position = step[1];

          // false = no step is set
          if (position === false) {
            position = 1;
          }

          // null = edge of slider
          if (position !== null) {
            setSliderHandle(handle, value + position);
          }

          break;

        case 40:
          position = step[0];

          if (position === false) {
            position = 1;
          }

          if (position !== null) {
            setSliderHandle(handle, value - position);
          }

          break;
      }
    });
  });
  /* end Listen to keypress on the input */
});


/* -------------------------------------------------------------------------
    Budget End Footer
* ------------------------------------------------------------------------- */


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-text-below-CL"] && !window.DesignMode) return;
  try {
    
$('.slider_wrap').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0619/0039/0599/files/t-arrow.png?v=1659541498' alt='slick-prev'></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0619/0039/0599/files/t-arrow.png?v=1659541498' alt='slick-next'></button>",
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('.sliderMin').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-text-overlay-CL"] && !window.DesignMode) return;
  try {
    
    var pricePoint = new Splide( '.price-point', {
    type: 'loop',
    perPage: 4,
    autoplay: false,
    interval: 8000,
    flickMaxPages: 3,
    updateOnMove: true,
    pagination: false,
    arrows: false,
    perMove: 1,
    gap    : '25px',
    breakpoints: {
        1024: {
            perPage: 4
          },
          767: {
            perPage: 2,
            padding:'5%',
          },
          480: {
            perPage: 2,
            padding:'40px',
            gap: 10,
          }
      },
  } );
  
  pricePoint.mount();
  
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.war = document.getElementById('wapper-header-sticky');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const collapseThreshold = this.headerBounds.bottom + 100; 
      if (scrollTop > this.currentScrollTop && scrollTop > collapseThreshold) {

        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > collapseThreshold) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('animate', 'shopify-section-header-sticky', 'shopify-section-header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["love-story-collection-landing"] && !window.DesignMode) return;
  try {
    
  let testimonialSlide = new Splide( '.testimonialSlide', {
  type: 'loop',
  perPage: 3,
  autoplay: true,
  interval: 8000,
  flickMaxPages: 3,
  updateOnMove: true,
  pagination: false,
  arrows: false,
  perMove: 1,
  gap    : '30px',
  breakpoints: {
      1024: {
          perPage: 3,
          perPage: 2,
        },
        767: {
          perPage: 2
        },
        480: {
          perPage: 1,
          pagination: true,
          arrows: true,
        }
    },
} );

testimonialSlide.mount();

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-filter-earrings"] && !window.DesignMode) return;
  try {
    

$(function() {
  
  setCheckboxSelectLabels();
  $("button.form-select").html("All");
  $('.toggle-next').click(function() {
    $(this).next('.checkboxes').slideToggle(400);
    var destination = $("#advFilter .modal-body ").offset().top + $("#advFilter .modal-body").height();
    $("#advFilter .modal-body").animate({ scrollTop: destination},"slow");
  });

  $(document).on('click', function(e) {
    var container = $(".toggle-next");
    if ($(e.target).closest(container).length == 0 && $(e.target).closest($("#Categories")).length == 0 ) {
      $("#Categories").hide();
    }
  });
  
  $('.ckkBox').change(function() {
    alert('chnage');
    toggleCheckedAll(this);
    setCheckboxSelectLabels(); 
  });

 
 
});
  
function setCheckboxSelectLabels(elem) {
  var wrappers = $('.wrapper'); 
   $(".designer_multiselector").find('button').text("Select");
  $.each( wrappers, function( key, wrapper ) {
    var checkboxes = $(wrapper).find('.ckkBox');
    var label = $(wrapper).find('.checkboxes').attr('id');
    var prevText = '';
    $.each( checkboxes, function( i, checkbox ) {
      var button = $(wrapper).find('button');
      if( $(checkbox).prop('checked') == true) {
        var text = $(checkbox).next().html();
        console.log(text);
        var btnText = prevText + text;
        var numberOfChecked = $(wrapper).find('input.val:checkbox:checked').length;
        if(numberOfChecked >= 4) {
           btnText = numberOfChecked +' Designers selected';
        }
        $(button).text(btnText); 
        prevText = btnText + ', ';
      }
    });
  });
}
function toggleCheckedAll(checkbox) {
  var apply = $(checkbox).closest('.wrapper').find('.apply-selection');
  apply.fadeIn('slow'); 
  
  var val = $(checkbox).closest('.checkboxes').find('.val');
  var all = $(checkbox).closest('.checkboxes').find('.all');
  var ckkBox = $(checkbox).closest('.checkboxes').find('.ckkBox');

  if(!$(ckkBox).is(':checked')) {
    $(all).prop('checked', true);
    return;
  }

  if( $(checkbox).hasClass('all') ) {
    $(val).prop('checked', false);
  } else {
    $(all).prop('checked', false);
  }
}
  

var a = document.querySelectorAll(".circleMetal li");
for (var i = 0, length = a.length; i < length; i++) {
  a[i].onclick = function() {
    var b = document.querySelector(".circleMetal li.active");
    if (b) b.classList.remove("active");
    this.parentNode.classList.add('active');
  };
}


/* -------------------------------------------------------------------------
      Budget begin Style-2
* ------------------------------------------------------------------------- */
   
var budgetPress = document.querySelector(".budget-range");
var input11 = document.querySelector(".budget-num-start");
var input12 = document.querySelector(".budget-num-end");
var inputs = [input11, input12];

noUiSlider.create(budgetPress, {
  start: [0,  3000],
  connect: true,
//   step: 1,
  range: {
    min: [0],
    max: [3000]
  },
  format: wNumb({
        decimals: 0,
        thousand: ',',
        prefix: '$ '
    })
});

/* begin Inputs  */

/* end Inputs  */
budgetPress.noUiSlider.on("update", function(values, handle) {
  inputs[handle].value = values[handle];

  /* begin Listen to keypress on the input */
  function setSliderHandle(i, value) {
    var r = [null, null];
    r[i] = value;
    budgetPress.noUiSlider.set(r);
  }

  // Listen to keydown events on the input field.
  inputs.forEach(function(input, handle) {
    input.addEventListener("change", function() {
      setSliderHandle(handle, this.value);
    });

    input.addEventListener("keydown", function(e) {
      var values = budgetPress.noUiSlider.get();
      var value = Number(values[handle]);

      // [[handle0_down, handle0_up], [handle1_down, handle1_up]]
      var steps = budgetPress.noUiSlider.steps();

      // [down, up]
      var step = steps[handle];

      var position;

      // 13 is enter,
      // 38 is key up,
      // 40 is key down.
      switch (e.which) {
        case 13:
          setSliderHandle(handle, this.value);
          break;

        case 38:
          // Get step to go increase slider value (up)
          position = step[1];

          // false = no step is set
          if (position === false) {
            position = 1;
          }

          // null = edge of slider
          if (position !== null) {
            setSliderHandle(handle, value + position);
          }

          break;

        case 40:
          position = step[0];

          if (position === false) {
            position = 1;
          }

          if (position !== null) {
            setSliderHandle(handle, value - position);
          }

          break;
      }
    });
  });
  /* end Listen to keypress on the input */
});

    
    /* -------------------------------------------------------------------------
       Budget end Style-2
     * ------------------------------------------------------------------------- */


/* -------------------------------------------------------------------------
      Budget Begin Start
* ------------------------------------------------------------------------- */
   
var budgetMinPress = document.querySelector(".budget-range-min");
var input25 = document.querySelector(".budget-num-start");
var input26 = document.querySelector(".budget-num-end");
var inputs = [input25, input26];

noUiSlider.create(budgetMinPress, {
  start: [0,  999900],
  connect: true,
//   step: 1,
  range: {
    min: [0],
    max: [1000000]
  },
  format: wNumb({
        decimals: 0,
        thousand: ',',
        prefix: '$ '
    })
});

/* begin Inputs  */

/* end Inputs  */
budgetMinPress.noUiSlider.on("update", function(values, handle) {
  inputs[handle].value = values[handle];

  /* begin Listen to keypress on the input */
  function setSliderHandle(i, value) {
                           var r = [null, null];
    r[i] = value;
    budgetMinPress.noUiSlider.set(r);
  }

  // Listen to keydown events on the input field.
  inputs.forEach(function(input, handle) {
    input.addEventListener("change", function() {
      setSliderHandle(handle, this.value);
    });

    input.addEventListener("keydown", function(e) {
      var values = budgetMinPress.noUiSlider.get();
      var value = Number(values[handle]);

      // [[handle0_down, handle0_up], [handle1_down, handle1_up]]
      var steps = budgetMinPress.noUiSlider.steps();

      // [down, up]
      var step = steps[handle];

      var position;

      // 13 is enter,
      // 38 is key up,
      // 40 is key down.
      switch (e.which) {
        case 13:
          setSliderHandle(handle, this.value);
          break;

        case 38:
          // Get step to go increase slider value (up)
          position = step[1];

          // false = no step is set
          if (position === false) {
            position = 1;
          }

          // null = edge of slider
          if (position !== null) {
            setSliderHandle(handle, value + position);
          }

          break;

        case 40:
          position = step[0];

          if (position === false) {
            position = 1;
          }

          if (position !== null) {
            setSliderHandle(handle, value - position);
          }

          break;
      }
    });
  });
  /* end Listen to keypress on the input */
});


/* -------------------------------------------------------------------------
    Budget End Footer
* ------------------------------------------------------------------------- */



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-filter-gemstone"] && !window.DesignMode) return;
  try {
    

$(function() {
  
  setCheckboxSelectLabels();
  $("button.form-select").html("All");
  $('.toggle-next').click(function() {
    $(this).next('.checkboxes').slideToggle(400);
    var destination = $("#advFilter .modal-body ").offset().top + $("#advFilter .modal-body").height();
    $("#advFilter .modal-body").animate({ scrollTop: destination},"slow");
  });

  $(document).on('click', function(e) {
    var container = $(".toggle-next");
    if ($(e.target).closest(container).length == 0 && $(e.target).closest($("#Categories")).length == 0 ) {
      $("#Categories").hide();
    }
  });
  
  $('.ckkBox').change(function() {
    alert('chnage');
    toggleCheckedAll(this);
    setCheckboxSelectLabels(); 
  });

 
 
});
  
function setCheckboxSelectLabels(elem) {
  var wrappers = $('.wrapper'); 
   $(".designer_multiselector").find('button').text("Select");
  $.each( wrappers, function( key, wrapper ) {
    var checkboxes = $(wrapper).find('.ckkBox');
    var label = $(wrapper).find('.checkboxes').attr('id');
    var prevText = '';
    $.each( checkboxes, function( i, checkbox ) {
      var button = $(wrapper).find('button');
      if( $(checkbox).prop('checked') == true) {
        var text = $(checkbox).next().html();
        console.log(text);
        var btnText = prevText + text;
        var numberOfChecked = $(wrapper).find('input.val:checkbox:checked').length;
        if(numberOfChecked >= 4) {
           btnText = numberOfChecked +' Designers selected';
        }
        $(button).text(btnText); 
        prevText = btnText + ', ';
      }
    });
  });
}
function toggleCheckedAll(checkbox) {
  var apply = $(checkbox).closest('.wrapper').find('.apply-selection');
  apply.fadeIn('slow'); 
  
  var val = $(checkbox).closest('.checkboxes').find('.val');
  var all = $(checkbox).closest('.checkboxes').find('.all');
  var ckkBox = $(checkbox).closest('.checkboxes').find('.ckkBox');

  if(!$(ckkBox).is(':checked')) {
    $(all).prop('checked', true);
    return;
  }

  if( $(checkbox).hasClass('all') ) {
    $(val).prop('checked', false);
  } else {
    $(all).prop('checked', false);
  }
}
  

var a = document.querySelectorAll(".circleMetal li");
for (var i = 0, length = a.length; i < length; i++) {
  a[i].onclick = function() {
    var b = document.querySelector(".circleMetal li.active");
    if (b) b.classList.remove("active");
    this.parentNode.classList.add('active');
  };
}


/* -------------------------------------------------------------------------
      Budget begin Style-2
* ------------------------------------------------------------------------- */
   
var budgetPress = document.querySelector(".budget-range");
var input11 = document.querySelector(".budget-num-start");
var input12 = document.querySelector(".budget-num-end");
var inputs = [input11, input12];

noUiSlider.create(budgetPress, {
  start: [0,  3000],
  connect: true,
//   step: 1,
  range: {
    min: [0],
    max: [3000]
  },
  format: wNumb({
        decimals: 0,
        thousand: ',',
        prefix: '$ '
    })
});

/* begin Inputs  */

/* end Inputs  */
budgetPress.noUiSlider.on("update", function(values, handle) {
  inputs[handle].value = values[handle];

  /* begin Listen to keypress on the input */
  function setSliderHandle(i, value) {
    var r = [null, null];
    r[i] = value;
    budgetPress.noUiSlider.set(r);
  }

  // Listen to keydown events on the input field.
  inputs.forEach(function(input, handle) {
    input.addEventListener("change", function() {
      setSliderHandle(handle, this.value);
    });

    input.addEventListener("keydown", function(e) {
      var values = budgetPress.noUiSlider.get();
      var value = Number(values[handle]);

      // [[handle0_down, handle0_up], [handle1_down, handle1_up]]
      var steps = budgetPress.noUiSlider.steps();

      // [down, up]
      var step = steps[handle];

      var position;

      // 13 is enter,
      // 38 is key up,
      // 40 is key down.
      switch (e.which) {
        case 13:
          setSliderHandle(handle, this.value);
          break;

        case 38:
          // Get step to go increase slider value (up)
          position = step[1];

          // false = no step is set
          if (position === false) {
            position = 1;
          }

          // null = edge of slider
          if (position !== null) {
            setSliderHandle(handle, value + position);
          }

          break;

        case 40:
          position = step[0];

          if (position === false) {
            position = 1;
          }

          if (position !== null) {
            setSliderHandle(handle, value - position);
          }

          break;
      }
    });
  });
  /* end Listen to keypress on the input */
});

    
    /* -------------------------------------------------------------------------
       Budget end Style-2
     * ------------------------------------------------------------------------- */


/* -------------------------------------------------------------------------
      Budget Begin Start
* ------------------------------------------------------------------------- */
   
var budgetMinPress = document.querySelector(".budget-range-min");
var input25 = document.querySelector(".budget-num-start");
var input26 = document.querySelector(".budget-num-end");
var inputs = [input25, input26];

noUiSlider.create(budgetMinPress, {
  start: [0,  999900],
  connect: true,
//   step: 1,
  range: {
    min: [0],
    max: [1000000]
  },
  format: wNumb({
        decimals: 0,
        thousand: ',',
        prefix: '$ '
    })
});

/* begin Inputs  */

/* end Inputs  */
budgetMinPress.noUiSlider.on("update", function(values, handle) {
  inputs[handle].value = values[handle];

  /* begin Listen to keypress on the input */
  function setSliderHandle(i, value) {
                           var r = [null, null];
    r[i] = value;
    budgetMinPress.noUiSlider.set(r);
  }

  // Listen to keydown events on the input field.
  inputs.forEach(function(input, handle) {
    input.addEventListener("change", function() {
      setSliderHandle(handle, this.value);
    });

    input.addEventListener("keydown", function(e) {
      var values = budgetMinPress.noUiSlider.get();
      var value = Number(values[handle]);

      // [[handle0_down, handle0_up], [handle1_down, handle1_up]]
      var steps = budgetMinPress.noUiSlider.steps();

      // [down, up]
      var step = steps[handle];

      var position;

      // 13 is enter,
      // 38 is key up,
      // 40 is key down.
      switch (e.which) {
        case 13:
          setSliderHandle(handle, this.value);
          break;

        case 38:
          // Get step to go increase slider value (up)
          position = step[1];

          // false = no step is set
          if (position === false) {
            position = 1;
          }

          // null = edge of slider
          if (position !== null) {
            setSliderHandle(handle, value + position);
          }

          break;

        case 40:
          position = step[0];

          if (position === false) {
            position = 1;
          }

          if (position !== null) {
            setSliderHandle(handle, value - position);
          }

          break;
      }
    });
  });
  /* end Listen to keypress on the input */
});


/* -------------------------------------------------------------------------
    Budget End Footer
* ------------------------------------------------------------------------- */



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-filter-setting"] && !window.DesignMode) return;
  try {
    

$(function() {
  
  setCheckboxSelectLabels();
  $("button.form-select").html("All");
  $('.toggle-next').click(function() {
    $(this).next('.checkboxes').slideToggle(400);
    var destination = $("#advFilter .modal-body ").offset().top + $("#advFilter .modal-body").height();
    $("#advFilter .modal-body").animate({ scrollTop: destination},"slow");
  });

    $(document).on('click', function(e) {
    var container = $(".toggle-next");
    if ($(e.target).closest(container).length == 0 && $(e.target).closest($("#Categories")).length == 0 ) {
    
        $("#Categories").hide();
    }
});
  
  $('.ckkBox').change(function() {
    alert('chnage');
    toggleCheckedAll(this);
    setCheckboxSelectLabels(); 
  });

 
 
});
  
function setCheckboxSelectLabels(elem) {
  var wrappers = $('.wrapper'); 
   $(".designer_multiselector").find('button').text("Select");
   $.each( wrappers, function( key, wrapper ) {
    var checkboxes = $(wrapper).find('.ckkBox');
    var label = $(wrapper).find('.checkboxes').attr('id');
    var prevText = '';
    $.each( checkboxes, function( i, checkbox ) {
      var button = $(wrapper).find('button');
      if( $(checkbox).prop('checked') == true) {
        var text = $(checkbox).next().html();
        console.log(text);
        var btnText = prevText + text;
        var numberOfChecked = $(wrapper).find('input.val:checkbox:checked').length;
        if(numberOfChecked >= 4) {
           btnText = numberOfChecked +' Designers selected';
        }
        $(button).text(btnText); 
        prevText = btnText + ', ';
      }
    });
  });
}
function toggleCheckedAll(checkbox) {
  var apply = $(checkbox).closest('.wrapper').find('.apply-selection');
  apply.fadeIn('slow'); 
  
  var val = $(checkbox).closest('.checkboxes').find('.val');
  var all = $(checkbox).closest('.checkboxes').find('.all');
  var ckkBox = $(checkbox).closest('.checkboxes').find('.ckkBox');

  if(!$(ckkBox).is(':checked')) {
    $(all).prop('checked', true);
    return;
  }

  if( $(checkbox).hasClass('all') ) {
    $(val).prop('checked', false);
  } else {
    $(all).prop('checked', false);
  }
}
  

var a = document.querySelectorAll(".circleMetal li");
for (var i = 0, length = a.length; i < length; i++) {
  a[i].onclick = function() {
    var b = document.querySelector(".circleMetal li.active");
    if (b) b.classList.remove("active");
    this.parentNode.classList.add('active');
  };
}


/* -------------------------------------------------------------------------
      Budget begin Style-2
* ------------------------------------------------------------------------- */
   
var budgetPress = document.querySelector(".budget-range");
var input11 = document.querySelector(".budget-num-start");
var input12 = document.querySelector(".budget-num-end");
var inputs = [input11, input12];

noUiSlider.create(budgetPress, {
  start: [0,  3000],
  connect: true,
//   step: 1,
  range: {
    min: [0],
    max: [3000]
  },
  format: wNumb({
        decimals: 0,
        thousand: ',',
        prefix: '$ '
    })
});

/* begin Inputs  */

/* end Inputs  */
budgetPress.noUiSlider.on("update", function(values, handle) {
  inputs[handle].value = values[handle];

  /* begin Listen to keypress on the input */
  function setSliderHandle(i, value) {
    var r = [null, null];
    r[i] = value;
    budgetPress.noUiSlider.set(r);
  }

  // Listen to keydown events on the input field.
  inputs.forEach(function(input, handle) {
    input.addEventListener("change", function() {
      setSliderHandle(handle, this.value);
    });

    input.addEventListener("keydown", function(e) {
      var values = budgetPress.noUiSlider.get();
      var value = Number(values[handle]);

      // [[handle0_down, handle0_up], [handle1_down, handle1_up]]
      var steps = budgetPress.noUiSlider.steps();

      // [down, up]
      var step = steps[handle];

      var position;

      // 13 is enter,
      // 38 is key up,
      // 40 is key down.
      switch (e.which) {
        case 13:
          setSliderHandle(handle, this.value);
          break;

        case 38:
          // Get step to go increase slider value (up)
          position = step[1];

          // false = no step is set
          if (position === false) {
            position = 1;
          }

          // null = edge of slider
          if (position !== null) {
            setSliderHandle(handle, value + position);
          }

          break;

        case 40:
          position = step[0];

          if (position === false) {
            position = 1;
          }

          if (position !== null) {
            setSliderHandle(handle, value - position);
          }

          break;
      }
    });
  });
  /* end Listen to keypress on the input */
});

    
    /* -------------------------------------------------------------------------
       Budget end Style-2
     * ------------------------------------------------------------------------- */


/* -------------------------------------------------------------------------
      Budget Begin Start
* ------------------------------------------------------------------------- */
   
var budgetMinPress = document.querySelector(".budget-range-min");
var input25 = document.querySelector(".budget-num-start");
var input26 = document.querySelector(".budget-num-end");
var inputs = [input25, input26];

noUiSlider.create(budgetMinPress, {
  start: [0,  999900],
  connect: true,
//   step: 1,
  range: {
    min: [0],
    max: [1000000]
  },
  format: wNumb({
        decimals: 0,
        thousand: ',',
        prefix: '$ '
    })
});

/* begin Inputs  */

/* end Inputs  */
budgetMinPress.noUiSlider.on("update", function(values, handle) {
  inputs[handle].value = values[handle];

  /* begin Listen to keypress on the input */
  function setSliderHandle(i, value) {
                           var r = [null, null];
    r[i] = value;
    budgetMinPress.noUiSlider.set(r);
  }

  // Listen to keydown events on the input field.
  inputs.forEach(function(input, handle) {
    input.addEventListener("change", function() {
      setSliderHandle(handle, this.value);
    });

    input.addEventListener("keydown", function(e) {
      var values = budgetMinPress.noUiSlider.get();
      var value = Number(values[handle]);

      // [[handle0_down, handle0_up], [handle1_down, handle1_up]]
      var steps = budgetMinPress.noUiSlider.steps();

      // [down, up]
      var step = steps[handle];

      var position;

      // 13 is enter,
      // 38 is key up,
      // 40 is key down.
      switch (e.which) {
        case 13:
          setSliderHandle(handle, this.value);
          break;

        case 38:
          // Get step to go increase slider value (up)
          position = step[1];

          // false = no step is set
          if (position === false) {
            position = 1;
          }

          // null = edge of slider
          if (position !== null) {
            setSliderHandle(handle, value + position);
          }

          break;

        case 40:
          position = step[0];

          if (position === false) {
            position = 1;
          }

          if (position !== null) {
            setSliderHandle(handle, value - position);
          }

          break;
      }
    });
  });
  /* end Listen to keypress on the input */
});


/* -------------------------------------------------------------------------
    Budget End Footer
* ------------------------------------------------------------------------- */



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["questions"] && !window.DesignMode) return;
  try {
    
    var questionWatch = new Splide( '.questionwatch', {
   // type: 'loop',
    perPage: 3,
    //autoplay: true,
   // interval: 8000,
    flickMaxPages: 3,
    updateOnMove: true,
    pagination: false,
    arrows: true,
    perMove: 1,
    gap    : '43px',
    breakpoints: {
        1024: {
            perPage: 3
          },
          767: {
            perPage: 2
          },
          480: {
            perPage: 1
          }
      },
  } );
  
  questionWatch.mount();
  
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial"] && !window.DesignMode) return;
  try {
    
$('.testimonialSlide').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000, 
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          dots: true,
           prevArrow:'<button type="button" class="slick-prev pull-left" aria-label="Previous Button"><svg width="12" height="19" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 1L2 9.04762L11 17.7143" stroke="#B29D95" stroke-width="1.5"/></svg></button>',
          nextArrow:'<button type="button" class="slick-next pull-right" aria-label="Next Button"><svg width="12" height="19" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L10 9.04762L1 17.7143" stroke="#B29D95" stroke-width="1.5"/></svg></button>',
       }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-collection-more-filter"] && !window.DesignMode) return;
  try {
    
$(function() {
  
  setCheckboxSelectLabels();
  $("button.form-select").html("All");
  $('.toggle-next').click(function() {
    $(this).next('.checkboxes').slideToggle(400);
    var destination = $("#advFilter .modal-body ").offset().top + $("#advFilter .modal-body").height();
    $("#advFilter .modal-body").animate({ scrollTop: destination},"slow");
  });

    $(document).on('click', function(e) {
    var container = $(".toggle-next");
    if ($(e.target).closest(container).length == 0 && $(e.target).closest($("#Categories")).length == 0 ) {
    
        $("#Categories").hide();
    }
});
  
  $('.ckkBox').change(function() {
    toggleCheckedAll(this);
    setCheckboxSelectLabels(); 
  });

 
 
});
  
function setCheckboxSelectLabels(elem) {
  var wrappers = $('.wrapper'); 
   $(".designer_multiselector").find('button').text("Select");
  $.each( wrappers, function( key, wrapper ) {
    var checkboxes = $(wrapper).find('.ckkBox');
    var label = $(wrapper).find('.checkboxes').attr('id');
    var prevText = '';
    $.each( checkboxes, function( i, checkbox ) {
      var button = $(wrapper).find('button');
      if( $(checkbox).prop('checked') == true) {
        var text = $(checkbox).next().html();
        var btnText = prevText + text;
        var numberOfChecked = $(wrapper).find('input.val:checkbox:checked').length;
        if(numberOfChecked >= 4) {
           btnText = numberOfChecked +' Designers selected';
        }
        $(button).text(btnText); 
        prevText = btnText + ', ';
      }
    });
  });
}

function toggleCheckedAll(checkbox) {
  var apply = $(checkbox).closest('.wrapper').find('.apply-selection');
  apply.fadeIn('slow'); 
  
  var val = $(checkbox).closest('.checkboxes').find('.val');
  var all = $(checkbox).closest('.checkboxes').find('.all');
  var ckkBox = $(checkbox).closest('.checkboxes').find('.ckkBox');

  if(!$(ckkBox).is(':checked')) {
    $(all).prop('checked', true);
    return;
  }

  if( $(checkbox).hasClass('all') ) {
    $(val).prop('checked', false);
  } else {
    $(all).prop('checked', false);
  }
}
  
var a = document.querySelectorAll(".circleMetal li");
for (var i = 0, length = a.length; i < length; i++) {
  a[i].onclick = function() {
    var b = document.querySelector(".circleMetal li.active");
    if (b) b.classList.remove("active");   
    this.parentNode.classList.add('active');
  };
}


  } catch(e) { console.error(e); }
})();
})();
